module.exports = __webpack_public_path__ + "static/media/avatar_11.19ce9d24.svg";